import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Warehousing from "../components/Warehousing"
import userGl from "../components/userGl"
import Warehouse from "../components/Warehouse"
import QueryPricing from "../components/QueryPricing"
import Stock from "../components/Stock"
import CashFlows from "../components/CashFlows"
import DengL from "../components/DengL"
import BaoGao from "../components/BaoGao"
Vue.use(Router)

const routes = [
    {path: '/DengL',component: DengL},
    {
        path: '/',component: Index,
        redirect:'/userGl',
        children:[
            {path: '/userGl',component: userGl},
            {path: '/Warehousing',component: Warehousing},
            {path: '/Warehouse',component: Warehouse},
            {path: '/QueryPricing',component: QueryPricing},
            {path: '/Stock',component: Stock},
            {path: '/CashFlows',component: CashFlows},
            {path: '/BaoGao',component: BaoGao},
        ]
    },
]

const router = new Router({
    mode: 'history',
    routes
  })


router.beforeEach((to, from, next) => {
    /* 路径跳转处理 */
    //console.log(JSON.parse(localStorage.getItem('userInfo')))
    if (!JSON.parse(localStorage.getItem('userInfo'))) {
        if(to.path!='/DengL'){
            next({path: '/DengL'})
            setTimeout('console.clear',300)
        }else{
            next();
        }
    } else {
        next()
    }
})
  
export default router




// WEBPACK FOOTER //
// ./src/router/index.js